module.exports = __webpack_public_path__ + "31dfe1854cefa276de26ac9fdbc2066e.svg";